import { AnyAction } from "redux";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAction = (action: any): action is AnyAction =>
  typeof action.type === "string";
